export enum EMeetingRoutes {
  HOME = '/',
  JOIN = '/join',
  REJOIN = '/rejoin',
  END = '/end',
  EXIT_ROOM = '/exitRoom',
  ROOM_FULL = '/room-full',
  RESTRICTED_ACCESS = '/restricted-access',
  TEST_NOISE = '/test-noise',
}
